<template>
  <div id="course-submtter-user-list">
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Course Submitters" key="1">
        <common-user-list :userListData="courseSubmitters"/>
      </a-tab-pane>
      <a-tab-pane tab="Certified Reviewers" key="2">
        <common-user-list :userListData="certifiedReviewers"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import commonUserList from '@src/components/dashboard/User-list.vue';

export default {
  name: 'course-submitter-user-list',
  components: {
    commonUserList,
  },
  computed: {
    ...mapGetters('dashboard', {
      courseSubmitters: 'getCourseSubmitters',
      certifiedReviewers: 'getCertifiedReviewers',
    }),
    ...mapGetters('user', {
      userToken: 'getUserToken',
    }),
    ...mapState('dashboard', {
      userInsName: state => state.userDetails.institution_name,
    }),
  },
  mounted() {
    this.$nextTick(() => {
      this.callPullData();
    });
  },
  methods: {
    ...mapActions('dashboard', {
      getUserByMeta: 'getUserByMeta',
    }),
    callPullData() {
      const getCourseSubmittersArgs = {
        roles: 'telas_course_submitters',
        'meta[0][key]': 'activated_by_admin',
        'meta[0][value]': 'yes',
        'meta[1][key]': 'institution_name',
        'meta[1][value]': this.userInsName,
        tab: 'courseSubmitters',
        userToken: this.userToken,
      };
      this.getUserByMeta(getCourseSubmittersArgs);
      const getCertifiedUsersArgs = {
        roles: 'telas_assessor',
        'meta[0][key]': 'telas_assessor_level',
        'meta[0][value]': 'telas_certified_reviewers',
        'meta[1][key]': 'activated_by_admin',
        'meta[1][value]': 'yes',
        'meta[2][key]': 'institution_name',
        'meta[2][value]': this.userInsName,
        tab: 'certifedReviewers',
        userToken: this.userToken,
      };
      this.getUserByMeta(getCertifiedUsersArgs);
    },
  },
  created() {
    this.$store.watch(
      (state, getters) => getters['user/getUserToken'],
      // eslint-disable-next-line no-unused-vars
      (newValue, oldValue) => {
        this.callPullData();
      },
    );
  },
};
</script>
